import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import BuyflowGuidelineForm from "./indexForm";
import { withStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { useHistory } from "react-router";
import { useStyles } from "../indexFormStyles";
import { getRoute } from "../../../helpers/utils";

function BuyflowGuideline({ classes: { loaderBox } }) {
  const history = useHistory();

  const [isLoaded, setIsLoaded] = useState(true);
  const [selectedOccupationOption, setSelectedOccupationOption] =
    useState(null);

  const handleBack = () => navigateTo(getRoute("declaration"));

  const navigateTo = (pathname) => history.push({ pathname });

  const onSubmit = (event) => {
    event.preventDefault();

    navigateTo(getRoute("proposalDetails"));
  };

  return isLoaded ? (
    <BuyflowGuidelineForm
      handleBack={handleBack}
      onSubmit={onSubmit}
      selectedOccupationOption={selectedOccupationOption}
      setSelectedOccupationOption={setSelectedOccupationOption}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(BuyflowGuideline);
